// DO NOT UPDATE MANUALLY: Generated from script during build time
export const VERSION = '14.1.0-beta.20260805';
